module.exports = __webpack_public_path__ + "img/add.e9b3255a.svg";